import AppDataService from "./AppDataService";

const COMMON_BASE = 'ManageForms'

export default class ManageFormsService {

    static async getFederalPayers() {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalPayers`);
    }

    static async getFederalForms() {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalForms`);
    }

    static async getStateForms() {
        return await AppDataService.get(`${COMMON_BASE}/GetStateForms`);
    }

    static async getStateFilingGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStateFilingGridData`, { params });
    }

    static async getFederalGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalGridData`, { params });
    }

    static async get94xGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/Get94xGridData`, { params });
    }

    static async getStatePDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePDF`, { params });
    }

    static async getStateExport(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStateExport`, { params })
    }

    static async getReconciliationGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationGridData`, { params })
    }

    static async getReconciliationPayers() {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationPayers`)
    }

    static async getReconciliationStates() {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationStates`)
    }

    static async blockStateFiling({ reconFormId, reconState, formName }) {
        return await AppDataService.put(`${COMMON_BASE}/BlockStateFiling?reconFormId=${reconFormId}&reconState=${reconState}&formName=${formName}`)
    }

    static async getReconciliationPDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationPDF`, { params })
    }

    static async blockReconciliation(reconFormId, reconState, formName) {
        return await AppDataService.put(`${COMMON_BASE}/BlockReconciliation?reconFormId=${reconFormId}&reconState=${reconState}&formName=${formName}`)
    }

    static async view94xPDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/View94xPDF`, { params });
    }

    static async downLoad94xPDFs(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownLoad94xPDFs`, { params });
    }

    static async getFederalExport(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalExport`, { params });
    }

    static async getFederalExportForAllPayers(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalExportForAllPayers`, { params });
    }

    static async getFederalExportForSelectedPayer(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalExportForSelectedPayer`, { params });
    }

    static async downLoadFedMultiplePDFs(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownLoadFedMultiplePDFs`, { params });
    }

    static async downloadFedPDFsByPayers(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownLoadFedPDFsByPayers`, { params });
    }

    static async downloadFedPDFsByReference(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownLoadFedPDFsByReference`, { params });
    }

    static async getFederalPDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalPDF`, { params });
    }

    static async blockFederalSubmission(referenceNumber, formId, State, formTypeId) {
        let completeUrl = "";
        if(formId && formTypeId){
            completeUrl = `referenceNumber=${referenceNumber}&formId=${formId}&State=${State}&formTypeId=${formTypeId}`;
        }else{
            completeUrl = `referenceNumber=${referenceNumber}&State=${State}`;
        }
        return await AppDataService.get(`${COMMON_BASE}/BlockFederalSubmission?${completeUrl}`);
    }

    static async changeFederalScheduleDate(scheduleDate, referenceId) {
        return await AppDataService.put(`${COMMON_BASE}/ChangeFederalScheduleDate?referenceId=${referenceId}&scheduledDate=${scheduleDate}`)
    }

    static async sendPayerCopyInMail({ payerId, taxYear, formName }) {
        return await AppDataService.get(`${COMMON_BASE}/SendPayerCopyInMail?payerId=${payerId}&taxYear=${taxYear}&formName=${formName}`)
    }

    static async emailToRecipient(params) {
        return await AppDataService.get(`${COMMON_BASE}/EmailToRecipient`, { params });
    }

    static async downLoadStatePDFs(params) {
        return await AppDataService.get(`${COMMON_BASE}/DownLoadStatePDFs`, { params })
    }

    static async sendPdfToPortal(data) {
        return await AppDataService.post(`${COMMON_BASE}/PDFToPortal`, data)
    }

    static async uspsMailtoRecipient(data) {
        return await AppDataService.post(`${COMMON_BASE}/USPSMailtoRecipient`, data)
    }

    static async stateFilingPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/StateFilingPayment`, data)
    }

    static async getBulkStateAmount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetBulkStateAmount`, data)
    }

    static async getBulkReferences(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetBulkReferences`, { params })
    }

    static async getSingleStateAmount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetSingleStateAmount`, data)
    }

    static async requestConsent(data) {
        return AppDataService.post(`${COMMON_BASE}/RequestConsent`, data)
    }

    static async getUSPSMailFee(data){
        return AppDataService.post(`${COMMON_BASE}/GetUSPSAmount`, data)
    }
    
    static async GetStatePayrollStates(){
        return AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`)
    }

    static async GetStatePayrollFormNames(params){
        return AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`)
    }

    static async GetStatePayrollTaxYears(){
        return AppDataService.get(`${COMMON_BASE}/GetStatePayrollTaxYears`)
    }

    static async GetStatePayrollPayers(params){
        return AppDataService.get(`${COMMON_BASE}/GetStatePayrollPayers?statePayrollFormId=${params}`)
    }

    static async getManageFormsStatePayrollGridData({ payer, taxYear, formId }) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormsGridData?payer=${payer}&taxYear=${taxYear}&formId=${formId}`);
    }

}
